import { useCallback } from 'react';
import { useOpenDeeplink } from '../../../../hooks';
import { useRootStackNavigation } from '../../../../hooks/useRootNavigation';

export const useMoveToHome = () => {
  const navigation = useRootStackNavigation();

  const { openDeeplink } = useOpenDeeplink();

  return useCallback(() => {
    const navigationState = navigation.getState();

    const hasStacks = navigationState.routes.length > 1;
    const hasHomeScreen =
      navigationState.routes.filter(route => route.name === 'Home').length > 0;

    if (hasHomeScreen && hasStacks) {
      navigation.popToTop();
      return;
    }

    openDeeplink('ably://home/today');
  }, [navigation, openDeeplink]);
};
